import { BellOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { handleDashboardRequest } from '../../../modules/dashboard/redux';
import { dispatch } from '../../../store';
import {
  MainLayout,
  SecondaryLayout,
  StyledContainer,
  StyledContent
} from '../../../styles/StyledComponents';
import SiderNav from '../../template/SiderNav';
import { FormattedMessage } from 'react-intl';

const { Title } = Typography;

class AdminDashboardPage extends Component {
  componentDidMount () {
    dispatch(handleDashboardRequest());
  }

  render () {
    const { user } = this.props;
    // PERCENTAGE LEVEL CALCULATIONS
    // Change to fetch from API
    const percentage = 80;
    const getPercentageLevel = () => {
      if (percentage >= 90) return 'excellent';
      if (percentage >= 75) return 'veryGood';
      if (percentage >= 50) return 'average';
      else return 'good';
    };
    const progressLevel = getPercentageLevel(percentage);
    return (
      <MainLayout hasSider>
        <SiderNav user={user} />
        <SecondaryLayout>
          <StyledContent>
            <Row gutter={[16, 16]}>
              {/* LEFT SIDE */}
              <Col lg={18}>
                <StyledContainer>
                  <Row gutter={[8, 16]}>
                    <Col>
                      <Title level={2} style={{ fontWeight: 'lighter' }}>
                        <FormattedMessage id="admin-dashboard.main.title"/>
                      </Title>
                    </Col>
                    <Col flex='auto'>
                      <Title level={2}>{user?.profile?.firstName?.toUpperCase()}</Title>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col>
                      <p>
                        <FormattedMessage
                          id="admin-dashboard.main.progressMessage"
                          values={{
                            percentage: <span style={{ fontWeight: 'bolder' }}>{percentage}</span>,
                            progressLevel:
                              <span style={{ fontWeight: 'bolder' }}>
                                <FormattedMessage id={`admin-dashboard.main.progressLevel.${progressLevel}`}/>
                              </span>
                          }}
                        />
                      </p>
                    </Col>
                  </Row>
                </StyledContainer>
                <Row gutter={[16, 16]}>
                  <Col lg={12} sm={20} xs={24}>
                    <StyledContainer />
                  </Col>
                  <Col lg={12} sm={20} xs={24}>
                    <StyledContainer />
                  </Col>
                </Row>
              </Col>
              {/* RIGHT SIDE */}
              <Col lg={6}>
                <Row gutter={[16, 16]}>
                  <Col lg={3}>
                    <SearchOutlined style={{ fontSize: 20 }} />
                  </Col>
                  <Col span={3}>
                    <BellOutlined style={{ fontSize: 20 }} />
                  </Col>
                  <Col span={16}>
                    <div style={{ textAlign: 'right' }}>
                      <Title level={5} style={{ lineHeight: 0.3 }}>
                        {`${user?.firstName?.toUpperCase()} ${user?.lastName?.toUpperCase()}`}
                      </Title>
                      <small>{user?.email}</small>
                    </div>
                  </Col>
                  <Col span={2}>
                    <UserOutlined style={{ fontSize: 20 }} />
                  </Col>
                </Row>
                <div style={{ margin: 40 }} />
                <Row gutter={[16, 16]}>
                  <Col flex={1}>
                    <StyledContainer />
                  </Col>
                </Row>
              </Col>
            </Row>
          </StyledContent>
        </SecondaryLayout>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    dashboard: state.dashboard.data,
    isLoading: state.dashboard.isLoading
  };
};

export default connect(mapStateToProps, {})(AdminDashboardPage);
